import React, { useEffect, useMemo, useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { tryNow } from "../../utils";
import classNames from "classnames";
import { ConsultFormModal } from "../../components/CommonFormModal";
import {
  AuthingButton,
  AuthingButtonArrow,
} from "../../components/AuthingButton";
import { logoLists } from "./bannerList";

export const HomePageBanner = ({
  banners = [],
  showBrandContainer = false,
}) => {
  const { t } = useTranslation();

  // const orders = useMemo(() => {
  //   return [
  //     {
  //       title: t("homePage.order1.title"),
  //       subtitle: t("homePage.order1.subtitle"),
  //       titleSmall: t("homePage.order1.titleSmall"),
  //       subtitleSmall: t("homePage.order1.subtitleSmall"),
  //       detailUrl: "https://console.authing.cn/login",
  //     },
  //     {
  //       title: t("homePage.order2.title"),
  //       subtitle: t("homePage.order2.subtitle"),
  //       titleSmall: t("homePage.order2.titleSmall"),
  //       subtitleSmall: t("homePage.order2.subtitleSmall"),
  //       detailUrl: "https://www.authing.cn/solutions/manufacturing",
  //     },
  //     {
  //       title: t("homePage.order3.title"),
  //       subtitle: t("homePage.order3.subtitle"),
  //       titleSmall: t("homePage.order3.titleSmall"),
  //       subtitleSmall: t("homePage.order3.subtitleSmall"),
  //       detailUrl: "https://www.authing.cn/solutions/finance",
  //     },
  //     {
  //       title: t("homePage.order4.title"),
  //       subtitle: t("homePage.order4.subtitle"),
  //       titleSmall: t("homePage.order4.titleSmall"),
  //       subtitleSmall: t("homePage.order4.subtitleSmall"),
  //       detailUrl: "https://www.authing.cn/solutions/software",
  //     },
  //   ];
  // }, [t]);

  const tabWrapper = useMemo(() => {
    return (
      <div className="swiper-wrapper">
        {[...logoLists, ...logoLists].map((order, index) => {
          return (
            <div
              className={classNames("container-order swiper-slide")}
              key={index}
            >
              <div className="item-logo">
                <div>
                  <img
                    src={order.logo}
                    alt={order.alt}
                    // style={{ width: "100%" }}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }, []);

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    new Swiper(".home-banner-swiper", {
      spaceBetween: 24,
      slidesPerView: 6,
      // slidesPerView:
      //   JSON.parse(sessionStorage.getItem("windowWidth")) > 1200 ? 12 : 4,
      // slidesPerView: "auto",
      loop: true,
      // centeredSlides: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    });
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      if (currentIndex < banners.length - 1) {
        setCurrentIndex(currentIndex + 1);
      } else {
        setCurrentIndex(0);
      }
    }, 5000);
    return () => clearInterval(timer);
  }, [banners.length, currentIndex]);

  const [visible, setVisible] = useState(false);
  // const tabWrapper = useMemo(() => {
  //   return (
  //     <div class="home-page-banner-carousel-container-order">
  //       {orders.map((order, index) => {
  //         const className = classNames({
  //           "container-order": true,
  //         });
  //         return (
  //           <div
  //             className={className}
  //             onClick={() => {
  //               window.open(order.detailUrl);
  //             }}
  //           >
  //             <div className="pc-show">
  //               <div className={"container-order-title"}>
  //                 {order.title}
  //                 {index === 0 && (
  //                   <i
  //                     className="icon authing-icon authing-hot2 lock"
  //                     style={{
  //                       color: "#E63333",
  //                       fontSize: 17,
  //                       marginLeft: 4,
  //                     }}
  //                   ></i>
  //                 )}
  //               </div>

  //               <div className={"container-order-subtitle"}>
  //                 {order.subtitle}
  //               </div>
  //             </div>
  //             <div className="mobile-show">
  //               <div className={"container-order-title"}>
  //                 {order.titleSmall}
  //               </div>
  //               <div className={"container-order-subtitle"}>
  //                 {order.subtitleSmall}
  //               </div>
  //             </div>
  //             <AuthingButtonArrow
  //               onClick={() => {
  //                 window.open(
  //                   "https://docs.authing.cn/v2/guides/connections/enterprise/windows-ad/"
  //                 );
  //               }}
  //               mode={"color-blue"}
  //               className="check-link"
  //             >
  //               {t("common.button.check-now")}
  //             </AuthingButtonArrow>
  //           </div>
  //         );
  //       })}
  //     </div>
  //   );
  // }, [orders, t]);

  return (
    <div
      className="home-page-banner"
      style={{
        backgroundImage: `url("//files.authing.co/authing-website/${banners[currentIndex].bg}")`,
        backgroundSize: "cover",
      }}
    >
      <div className="home-page-banner-carousel-container-warp">
        {banners.map((item, index) => {
          const className = classNames({
            "home-page-banner-carousel-container": true,
            visible: currentIndex === index,
          });
          return (
            <div className={className}>
              <div className="container-item basic-column">
                <h1 className="slogn">
                  <div>{item.title}</div>
                  <div>{item.title2}</div>
                </h1>
                {/* <div className="pc-show"> */}
                <div className="descrption">{item.subtitle}</div>
                {/* </div> */}
                {/* <div className="mobile-show">
                  <div className="descrption">{item.subtitleSmall}</div>
                </div> */}
                <div className="banner-button-warp">
                  <AuthingButton
                    style={{ marginRight: 24 }}
                    className="banner-button"
                    onClick={() => {
                      if (item.btnUrl) {
                        window.open(item.btnUrl);
                      } else {
                        tryNow();
                      }
                    }}
                  >
                    {item.btnName || t("common.try-on")}
                  </AuthingButton>
                  {item.link ? (
                    <AuthingButton
                      mode="light"
                      className="banner-button"
                      onClick={() => {
                        // setVisible(true);

                        window.open(item.link);
                      }}
                    >
                      {item.linkName}
                    </AuthingButton>
                  ) : (
                    <AuthingButton
                      mode="light"
                      className="banner-button"
                      onClick={() => {
                        // setVisible(true);
                        window.open(
                          "https://www.authing.cn/authingform?fromTag=首页第一屏"
                        );
                      }}
                    >
                      {t("common.button.consult")}
                    </AuthingButton>
                  )}
                </div>
                {banners.length > 1 && (
                  <div className="progress-dot-warp">
                    {banners.map((item, index) => {
                      const className = classNames({
                        "progress-dot": true,
                        checked: currentIndex === index,
                      });
                      return (
                        <div
                          className={className}
                          onClick={() => {
                            setCurrentIndex(index);
                          }}
                        ></div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          );
        })}

        {showBrandContainer && (
          <div className="home-page-banner-carousel">
            <div className="basic-column">
              <div className="swiper home-banner-swiper">{tabWrapper}</div>
            </div>
          </div>
        )}

        {/* <div className="scroll-mask"></div> */}
        {/* <div className="home-page-banner-carousel">
          <div className="home-page-banner-logo-warp">
           
            <div className="scroll-container">
              {logoLists.map((item, index) => {
                return (
                  <div key={index} className="customer-item">
                    <div className="customer-logo">
                      <img src={item.logo} alt={item.name} />
                    </div>
                    {HoverText(item)}
                  </div>
                );
              })}
              {logoLists.map((item, index) => {
                return (
                  <div key={`${index}-copy`} className="customer-item">
                    <div className="customer-logo">
                      <img src={item.logo} alt={item.name} />
                    </div>
                   
                  </div>
                );
              })}
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};
